<script>
import appConfig from '@src/app.config'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
  <RouterView :key="$route.fullPath" />
</template>

<style src="./design/styleOverrides.scss" lang="scss"></style>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.

// Design variables and utilities from src/design.
@use '@design' as *;

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  background: $color-body-bg;
  overscroll-behavior: none;
  label {
    padding-bottom: 5px !important;
    margin-bottom: 0;
  }
}
#app {
  @extend %typography-small;
}

// ===
// Base element styles
// ===

h1 {
  @extend %typography-xxlarge;
}

h2 {
  @extend %typography-xlarge;
}

h3 {
  @extend %typography-large;

  margin-bottom: 1rem;
}

h4 {
  @extend %typography-medium;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $color-nprogress-blue;
}
</style>
